var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceShipY(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 287,
    viewBox: "0 0 177 287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 287
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 287,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531.901 1111.124) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(840.148 544.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.227,0C209.013,0,298.011,33.83,298.011,75.562s-89,75.562-198.784,75.562S74.44,112.565,74.44,70.833-10.558,0,99.227,0Z",
    transform: "translate(-43.06 0)",
    fill: "#858585",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.962,0C82.212,0,129.8,25.184,129.8,52.917s-47.585,58.013-76.835,58.013S0,86.1,0,55.465,23.712,0,52.962,0Z",
    transform: "translate(114.379 20.681)",
    fill: "#fbb040",
    opacity: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceShipY);
export default __webpack_public_path__ + "static/media/spaceShip-y.7b79efc641067cc1c7bba0267ec338b5.svg";
export { ForwardRef as ReactComponent };